import FAQSection from "@/components/us-website/FAQSection/FAQSection";

/**
 * FAQ section as a landing-page section type. Thin adapter over the shared
 * `FAQSection` — passes the config's `items` ([{question, answer}]) through and
 * keeps the contact card hidden (landing pages have their own CTA section).
 *
 * `FAQSection` renders "FAQs - {industryName}", so `subject` supplies that
 * suffix (e.g. "Chemical Toll Manufacturing"). Omit it and the heading is a
 * plain "FAQs" rather than a dangling "FAQs - ".
 *
 * The config's `heading` is accepted as a fallback for `subject` so a config that
 * says `heading: "Frequently Asked Questions"` is not silently ignored — but note
 * FAQSection always prefixes "FAQs", so a `subject` reads better than a full
 * sentence here.
 *
 * The coral "FREQUENTLY ASKED QUESTIONS" eyebrow (Figma `4670-7146`) is passed
 * here for ALL 21 landing pages — this reverses Session 3's decision 1, which
 * dropped the label because no section accepted an eyebrow. `FAQSection` now takes
 * one as an OPT-IN prop, so the 8 non-landing consumers of that component are
 * unaffected. Override per config with `eyebrow`; pass `eyebrow: null` to hide it.
 */
const DEFAULT_EYEBROW = "Frequently Asked Questions";

export default function FaqBlock({
  items = [],
  subject,
  industryName,
  eyebrow = DEFAULT_EYEBROW,
}) {
  if (!items.length) return null;

  return (
    <FAQSection
      faqs={items}
      industryName={subject || industryName || ""}
      eyebrow={eyebrow || ""}
      hideContactCard
      backgroundColor="#ffffff"
    />
  );
}
